import * as Vue from "vue";
import { ActionContext, Store } from "vuex";
import { getStoreAccessors } from "vuex-typescript";
import {RootState} from "../store";

  type ApplicationContext = ActionContext<ApplicationState, RootState>;

  export interface ApplicationState {
    globalLoader: boolean;
    env: string;
  }

  export const applicationModule = {
    namespaced: true,
  
      state: {
      env: null,
        globalLoader: false
    },

    getters: {
      getCurrentEnv(state: ApplicationState): string {
          return state.env;
        }
    },

    mutations: {
      startLoader(state: ApplicationState) {
          state.globalLoader = true;
        },
      stopLoader(state: ApplicationState) {
          state.globalLoader = false;
        }
    },

    actions: {
  
      }

  };

const { commit, read, dispatch } = getStoreAccessors<ApplicationState, RootState>("application");

const getters = applicationModule.getters;
const actions = applicationModule.actions;
const mutations = applicationModule.mutations;

  export const application = {
    readCurrentEnv: read(getters.getCurrentEnv),
  
      commitStartLoader: commit(mutations.startLoader),
    commitStopLoader: commit(mutations.stopLoader)
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/application.ts